function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1913 1913",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.973,382.601L316.492,382.601L316.492,273.471C316.492,251.638 305.584,229.814 278.297,229.374L277.427,229.374C251.01,229.374 240.103,251.863 240.103,273.471L240.103,382.601L174.621,382.601L174.621,175.249L240.103,175.249L240.103,203.182C240.103,203.182 261.16,175.249 303.507,175.249C346.838,175.249 381.973,205.043 381.973,265.389L381.973,382.601ZM76.398,114.893C76.398,99.618 89.494,87.934 109.139,87.934C128.784,87.934 141.113,99.618 141.88,114.893C141.88,130.17 129.654,142.508 109.139,142.508C89.494,142.508 76.398,130.17 76.398,114.893ZM141.88,175.249L141.88,382.601L76.398,382.601L76.398,175.249L141.88,175.249ZM403.807,0.629L54.564,0.629C24.639,0.638 0.009,25.268 0,55.193L0,404.435C0.009,434.36 24.639,458.991 54.564,459.001L403.807,459.001C433.732,458.991 458.363,434.36 458.371,404.435L458.371,55.193C458.363,25.268 433.732,0.638 403.807,0.629Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.00e0308f.svg";
export { ForwardRef as ReactComponent };